<i [class]="iconMap.get(type) + ' small'"></i>
<p class="small">
	<ng-content></ng-content>
</p>
